import __cloneDeep from 'lodash/cloneDeep';

export const getAvailablePackages = (state) => {
  if (state.content.available) {
    return Object.keys(state.content.available);
  }

  return [];
};

export const getPackagesExpiry = (state) => {
  if (state.content.config) {
    return state.content.config.expiry;
  }

  return null;
};

export const getPackage = state => (name) => {
  if (!state.content || !name) {
    return null;
  }

  if (name.indexOf('.') >= 0) {
    const deconstructedName = name.split('.');
    const packageName = deconstructedName[0];
    const subPackageName = deconstructedName[1];

    return __cloneDeep(state.content.available[packageName].children.available[subPackageName]);
  }

  return __cloneDeep(state.content.available[name]);
};

export const getPackageMeta = state => name => state.content.available[name].meta;
export const getPackageComponents = state => name => state.content.available[name].components;


export const getPackageConfig = state => name => state.content.available[name].config;

export const getActivePackageConfig = (state, getters, rootState, rootGetters) => {
  const name = rootGetters['simulation/getPackage'];

  if (!state.content || !name) {
    return {
      features: {}
    };
  }

  if (name.indexOf('.') >= 0) {
    const deconstructedName = name.split('.');
    const packageName = deconstructedName[0];
    const subPackageName = deconstructedName[1];

    return state.content.available[packageName].children.available[subPackageName].config;
  }

  return state.content.available[name].config;
};

export const getActivePackageMeta = (state, getters, rootState, rootGetters) => {
  const name = rootGetters['simulation/getPackage'];

  if (!state.content || !name) {
    return {
      features: {}
    };
  }

  if (name.indexOf('.') >= 0) {
    const deconstructedName = name.split('.');
    const packageName = deconstructedName[0];
    const subPackageName = deconstructedName[1];

    return state.content.available[packageName].children.available[subPackageName].meta;
  }

  return state.content.available[name].meta;
};

export const getConfig = state => state.content.config;
export default {
  getAvailablePackages,
  getPackagesExpiry,
  getPackage,
  getPackageMeta,
  getPackageConfig,
  getConfig,
  getActivePackageConfig,
  getActivePackageMeta,
  getPackageComponents
};



// WEBPACK FOOTER //
// ./src/store/modules/packages/getters.js